import React from 'react';
import { Redirect, Route, Switch, useRouteMatch } from "react-router-dom";

import ProjetosList from './ProjetosList';
import ProjetoView from './ProjetoView';
import MargemList from './MargemList';
import MargemView from './MargemView';
import ProjetoDashboard from './ProjetoDashboard';
//import ProjetoPrevistoViewLegado from './ProjetoPrevistoViewLegado';
import ProjetoPrevistoView from './ProjetoPrevistoView';

function Projetos() {
    const match = useRouteMatch();

    return (
        <Switch>
            <Route path={`${match.path}`} exact component={ProjetosList} />
            <Route path={`${match.path}/:key/:id`} exact component={ProjetoView} />
            <Route path={`${match.path}/compare/:key/:id`} exact component={ProjetoDashboard} />
            <Route path={`${match.path}/meus/relatorios/margem`} exact component={MargemList} />
            <Route path={`${match.path}/meus/relatorios/margem/:id`} exact component={MargemView} />
            {/* <Route path={`${match.path}/previsaoLegado/:key/:id`} exact component={ProjetoPrevistoViewLegado} /> */}
            <Route path={`${match.path}/previsao/:key/:id`} exact component={ProjetoPrevistoView} />

            <Redirect path="*" to="/" />
        </Switch>
    )
}

export default Projetos;
